import { Navigate, useLocation } from "react-router-dom";

import type { TokenTab } from "@/features/product/types";

export function PlatformTokenEntryRedirect({
  tab = "integration",
}: {
  tab?: TokenTab;
}) {
  const { search } = useLocation();

  return (
    <Navigate replace to={{ pathname: `/platform-token/${tab}`, search }} />
  );
}
